import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function ThankYouPage() {
  const { t } = useTranslation();
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(180deg, #fafaf7 0%, #ffffff 100%)', padding: '80px 20px' }}>
      <div style={{ maxWidth: 640, textAlign: 'center' }}>
        <div style={{ width: 72, height: 72, margin: '0 auto', border: '1px solid var(--gd-navy)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#0b2545" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>
        </div>
        <span className="chip" style={{ marginTop: 28 }}>{t('thankYou.badge')}</span>
        <h1 className="font-serif mt-4" style={{ fontSize: 'clamp(30px, 4.5vw, 48px)', color: 'var(--gd-navy)', letterSpacing: '-0.01em' }}>
          {t('thankYou.title')}
        </h1>
        <p className="mt-4" style={{ color: '#334155', lineHeight: 1.7, fontSize: 16.5 }}>
          {t('thankYou.body')}
        </p>
        <div className="mt-8">
          <Link to="/" className="btn-primary">{t('thankYou.cta')}</Link>
        </div>

        <div style={{ marginTop: 48, fontSize: 12.5, color: 'var(--gd-mineral)' }}>
          Geodatosarg · Andes Datos Analíticos S.A.S. · CUIT 30-71742039-8
        </div>
      </div>
    </div>
  );
}
